import styled from 'styled-components';
import { Body4, Body6 } from './../../app/common/typography';

export const ContentArea = styled.div`
  margin-top: 162px;
  margin-right: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.none};
  margin-left: ${({ theme }) => theme.spacing.m};
`;

export const NoNotificationContents = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const TextWrapper = styled.p`
  margin: ${({ theme }) => theme.spacing.s} auto
    ${({ theme }) => theme.spacing.none};
  max-width: 311px;
  text-align: center;
`;

export const NotificationEmpty = styled.div`
  margin: ${({ theme }) => theme.spacing.none} ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NotificationContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-bottom: 100px;
`;

export const NotificationHeading = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xm};
  margin-right: ${({ theme }) => theme.spacing.m};
  margin-left: ${({ theme }) => theme.spacing.m};
`;

export const ButtonContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  margin-top: ${({ theme }) => theme.spacing.xl};
`;

export const OverdueCountsContent = styled.div`
  display: flex;
  align-items: center;
`;

export const RedDotContaier = styled.span`
  margin-right: ${({ theme }) => theme.spacing.s};
  height: ${({ theme }) => theme.spacing.s};
  width: ${({ theme }) => theme.spacing.s};
  background-color: ${({ theme }) => theme.colors.redCrayola};
  border-radius: ${({ theme }) => theme.radius.s};
  display: inline-block;
`;

export const BottomSheetContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;

export const ControlSelectContainer = styled.div``;

export const MenuContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.md}
    ${({ theme }) => theme.spacing.none};
  display: flex;
  justify-content: center;
`;

export const ChartContainer = styled.div`
  position: relative;
  height: 245px;
  width: 234px;
  overflow: hidden;
  margin-top: -20px;
  transform: rotate(-1deg);
  .lefttop {
    position: relative;
    transform: rotate(2deg) translate(6px, -3px);
  }
  .righttop {
    transform: rotate(122deg);
    position: relative;
    top: -9px;
    left: 5px;
  }
  .cbottom {
    position: relative;
    transform: rotate(-118deg) translate(80px, 118px);
  }
`;

export const LeftTopDetail = styled.div`
  position: absolute;
  left: -15px;
  top: 46px;
  transform: rotate(332deg);
  overflow: hidden;
  width: 151px;
  height: 103px;
  border-radius: 130px 0px 130px 0;
  z-index: 3;
  svg {
    width: 210px;
    height: 200px;
    transform: rotate(-4deg) translate(2px, -4px);
    textPath {
      color: ${({ theme }) => theme.colors.white};
      font-family: 'Source Sans Pro';
      font-size: 35px;
      font-weight: ${({ theme }) => theme.fontWeight.semiBold};
      letter-spacing: 3.5px;
      line-height: 25px;
    }
  }
  span {
    position: absolute;
    top: 38px;
    left: 39px;
    transform: rotate(-34deg);
    font-size: 30px;
    color: ${({ theme }) => theme.colors.white};
    min-width: 80px;
    text-align: center;
  }
`;

export const RightTopDetail = styled.div`
  position: absolute;
  right: -17px;
  top: 47px;
  transform: rotate(96deg);
  z-index: 2;
  overflow: hidden;
  width: 150px;
  height: 109px;
  border-radius: 160px 0px 160px 0;
  svg {
    width: 210px;
    height: 200px;
    transform: rotate(-21deg) translate(1px, -1px);
    textPath {
      color: ${({ theme }) => theme.colors.white};
      font-family: 'Source Sans Pro';
      font-size: 35px;
      font-style: normal;
      font-weight: ${({ theme }) => theme.fontWeight.semiBold};
      letter-spacing: 3.5px;
      line-height: 25px;
    }
  }
  span {
    position: absolute;
    top: 38px;
    left: 36px;
    transform: rotate(319deg);
    font-size: 30px;
    color: ${({ theme }) => theme.colors.white};
    min-width: 80px;
    text-align: center;
  }
`;

export const BottomDetail = styled.div`
  position: absolute;
  left: 5px;
  top: 22px;
  transform: rotate(23deg);
  z-index: 1;
  overflow: hidden;
  width: 217px;
  height: 214px;
  border-radius: 160px 150px 160px 150px;
  svg {
    width: 210px;
    transform: rotate(0deg) translate(15px, 15px);
    textPath {
      color: ${({ theme }) => theme.colors.white};
      font-family: 'Source Sans Pro';
      font-size: 35px;
      font-style: normal;
      font-weight: ${({ theme }) => theme.fontWeight.semiBold};
      letter-spacing: 3.5px;
      line-height: 25px;
    }
  }
  span {
    position: absolute;
    left: 87px;
    transform: rotate(-22deg);
    color: ${({ theme }) => theme.colors.white};
    font-weight: 500;
    min-width: 101px;
    text-align: center;
  }
`;

export const TextMyAuditCount = styled.span`
  bottom: 33px;
  font-size: 30px;
`;

export const TextComingSoon = styled(Body4)`
  bottom: 46px;
`;

export const CenterDetail = styled.div`
  position: absolute;
  left: calc(50% - 36px);
  top: calc(50% - 28px);
  width: 64px;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.titleBlue};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 4px solid ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.white};
  z-index: 4;
`;

export const TextCreatNew = styled(Body6)`
  max-width: 52px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
`;

export const OverdueCountsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.s};
`;
